import React from "react";

const Section1 = () => {
  return (
    <section className="py-20 bg-white px-4 max-w-6xl mx-auto">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div>
          {/* Badge */}
          <span className="text-[11px] bg-[#E6F5E8] text-[#137547] font-semibold px-4 py-1 rounded-full inline-block mb-4 tracking-wide uppercase">
            Why Choose us
          </span>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A033C] mb-6 leading-snug">
Fast, flexible & powerful digital solutions
          </h2>

          {/* Paragraph */}
          <p className="text-[#6B7280] text-base leading-relaxed mb-10">
From custom websites to complex applications, MinterMinds delivers blazing-fast, user-friendly solutions tailored to your business needs. Our team combines creativity with performance, ensuring seamless experiences—whether it's branding, development, or scaling.          </p>

          {/* Score Box */}
          <div className="border-t border-[#6B7280] pt-6 flex flex-wrap gap-6">
            {/* Pingdom Score */}
            <div className="flex items-center gap-4">
              <div className="bg-[#BDE7F1] text-[#0A033C] font-bold text-xl px-6 py-3 rounded-md">
                94
              </div>
              <div>
                <p className="text-[#0A033C] font-bold">512 ms</p>
                <p className="text-sm text-gray-500">Pingdom</p>
              </div>
            </div>

            {/* Google Page Speed Score */}
            <div className="flex items-center gap-4">
              <div className="bg-[#DDF6E2] text-[#0A033C] font-bold text-xl px-6 py-3 rounded-md">
                98
              </div>
              <div>
                <p className="text-[#0A033C] font-bold">653 ms</p>
                <p className="text-sm text-gray-500">Google Page Speed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="flex justify-center md:justify-end">
          <img
            src="/section1.png"
            alt="Speed Preview"
            className="max-w-full shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default Section1;
